import { Component, OnInit } from '@angular/core';
import { Customer } from '../../../dto/customer';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomersService } from '../../services/customers.service';
import { Location } from '@angular/common';
import { CountryService } from '../../../services';
import { Country } from '../../../dto/country';
import { PHONE_MASK } from '../../../helpers/format-helpers';
import {RoleService} from '../../../services/role.service';

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.css']
})
export class CustomerEditComponent implements OnInit {

  card: Customer;
  customerForm: FormGroup;
  countries: Country[];
  phoneMask = PHONE_MASK;
  constructor(
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private countryService: CountryService,
    private formBuilder: FormBuilder,
    private location: Location,
    private roleService: RoleService
  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null) {

    } else {
      this.customersService.get(parseInt(id)).subscribe(result => {
        result.cards = [];
        result.orders = [];
        this.initForm(result);
      });
    }
    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
    });
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  initForm(customer: Customer) {
    this.customerForm = this.formBuilder.group(customer);

    if( !this.currentUserIsAdmin() ){
      this.customerForm.controls['address'].disable();
      this.customerForm.controls['city'].disable();
      this.customerForm.controls['countryIsoCode'].disable();
      this.customerForm.controls['zipCode'].disable();
      this.customerForm.controls['isCollectionExempt'].disable();
    }
  }

  returnBack() {
    this.location.back();
  }

  onSubmit() {
    this.customersService.update(this.customerForm.getRawValue())
      .subscribe(res => {
this.returnBack();
});
  }
}
